module.exports = __webpack_public_path__ + "media/long-expected.c4f58295.mp3";